"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[456],{

/***/ 5426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCustodiaMark = function SvgCustodiaMark(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 536 603",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
    id: "custodia-mark_svg__a",
    gradientTransform: "rotate(120 .711 1.077)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: "0%",
    stopColor: "#FB5341"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: "25%",
    stopColor: "#FFC425"
  })))), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "url('#a')",
    d: "M103.332 413.781c-3.053 7.217-7.748 15.884-12.832 24.778-15.223 26.629-34.859 54.573-34.859 54.573a11.95 11.95 0 0 0 9.921 18.758l61.708-.142 238.903-.235c16.463.631 26.766 9.978 26.992 20.846.215 10.326-9.068 19.151-26.523 21.754l-335.465 6.642c-5.543.04-10.01 4.573-9.969 10.116.04 5.542 4.573 10.009 10.115 9.969l336.577 1.758c.625-.005 1.248-.05 1.867-.137 37.112-5.313 52.106-29.14 51.483-50.798-.662-23.047-19.407-46.818-54.418-47.715a14.596 14.596 0 0 0-.512-.006l-239.241 3.149h-.017l-39.206.572c8.505-13.259 19.689-31.402 28.16-47.685 7.142-13.728 12.28-26.358 13.26-34.378.501-4.03-.557-8.109-5.002-11.248-1.597-1.128-5.796-2.804-12.121-3.085-11.932-.532-37.676 1.412-51.755 1.102-2.574-50.792 13.403-109.441 39.078-161.675 27.931-56.826 67.573-106.097 109.714-126.391 25.556-12.674 48.934-10.215 65.623-14.971 9.941-2.832 18.348-7.328 25.195-14.148 9.138-9.101 18.702-14.855 27.704-18.184a76.291 76.291 0 0 1 8.599-2.626c-2.279 7.305-4.335 14.627-4.781 18.429-1.428 12.199 3.853 19.637 8.669 22.975 32.502 22.503 82.19 51.046 116.533 76.205 12.294 9.007 22.557 17.367 28.742 24.851 1.762 2.131 3.727 5.49 3.976 5.922-3.292 24.552-37.861 37.263-43.82 49.384-4.772-7.181-12.502-15.951-22.622-23.046-11.039-7.74-24.683-13.629-39.641-13.83-18.988-.265-32.021 1.508-42.534-3.362-6.073-2.813-10.85-8.267-15.938-17.728-2.836-5.274-7.974-8.758-15.983-6.6-5.514 1.486-16.969 10.264-24.281 21.239-10.192 15.296-10.969 32.488 3.422 40.357 24.945 13.655 41.969 33.285 54.154 55.683 19.975 36.717 27.356 80.605 34.56 119.034.984 5.454 6.212 9.083 11.667 8.099 5.454-.985 9.083-6.213 8.099-11.667-7.043-40.576-14.607-86.784-35.099-125.75-13.638-25.933-32.921-48.691-61.14-64.955.108-.479.256-1.07.407-1.484.534-1.459 1.328-2.935 2.229-4.402 1.613-2.625 4.394-5.64 6.928-8.119 6.339 9.216 13.09 14.765 20.543 18.36 12.917 6.231 28.923 5.754 52.418 6.45 9.611.29 18.212 4.512 25.214 9.617 9.384 6.842 16.167 15.274 17.348 19.45 2.033 7.188 7.01 11.531 14.319 13.145 7.168 1.584 19.801-1.369 32.96-9.941 20.043-13.054 42.213-38.546 46.086-67.349 1.544-10.965-7.574-27.73-26.484-45.175-29.253-26.988-81.768-61.195-118.737-88.628 3.56-9.022 9.458-24.437 10.744-30.561 3.832-18.255-8.05-26.375-16.313-28.651-10.04-2.745-30.784-4.613-54.643 3.098-14.417 4.66-29.927 13.074-44.861 26.913-4.04 3.825-10.081 3.688-16.741 4.772-9.889 1.609-20.998 3.171-32.912 6.418-9.531 2.598-19.525 6.179-29.75 11.698-47.378 26.066-92.179 83.879-120.538 151.368-25.763 61.313-38.512 129.876-29.692 186.465.35 2.905 4.553 10.541 16.003 11.419 10.626.814 33.525-.613 48.51-.696Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M103.332 413.781c-3.053 7.217-7.748 15.884-12.832 24.778-15.223 26.629-34.859 54.573-34.859 54.573a11.95 11.95 0 0 0 9.921 18.758l61.708-.142 238.903-.235c16.463.631 26.766 9.978 26.992 20.846.215 10.326-9.068 19.151-26.523 21.754l-335.465 6.642c-5.543.04-10.01 4.573-9.969 10.116.04 5.542 4.573 10.009 10.115 9.969l336.577 1.758c.625-.005 1.248-.05 1.867-.137 37.112-5.313 52.106-29.14 51.483-50.798-.662-23.047-19.407-46.818-54.418-47.715a14.596 14.596 0 0 0-.512-.006l-239.241 3.149h-.017l-39.206.572c8.505-13.259 19.689-31.402 28.16-47.685 7.142-13.728 12.28-26.358 13.26-34.378.501-4.03-.557-8.109-5.002-11.248-1.597-1.128-5.796-2.804-12.121-3.085-11.932-.532-37.676 1.412-51.755 1.102-2.574-50.792 13.403-109.441 39.078-161.675 27.931-56.826 67.573-106.097 109.714-126.391 25.556-12.674 48.934-10.215 65.623-14.971 9.941-2.832 18.348-7.328 25.195-14.148 9.138-9.101 18.702-14.855 27.704-18.184a76.291 76.291 0 0 1 8.599-2.626c-2.279 7.305-4.335 14.627-4.781 18.429-1.428 12.199 3.853 19.637 8.669 22.975 32.502 22.503 82.19 51.046 116.533 76.205 12.294 9.007 22.557 17.367 28.742 24.851 1.762 2.131 3.727 5.49 3.976 5.922-3.292 24.552-37.861 37.263-43.82 49.384-4.772-7.181-12.502-15.951-22.622-23.046-11.039-7.74-24.683-13.629-39.641-13.83-18.988-.265-32.021 1.508-42.534-3.362-6.073-2.813-10.85-8.267-15.938-17.728-2.836-5.274-7.974-8.758-15.983-6.6-5.514 1.486-16.969 10.264-24.281 21.239-10.192 15.296-10.969 32.488 3.422 40.357 24.945 13.655 41.969 33.285 54.154 55.683 19.975 36.717 27.356 80.605 34.56 119.034.984 5.454 6.212 9.083 11.667 8.099 5.454-.985 9.083-6.213 8.099-11.667-7.043-40.576-14.607-86.784-35.099-125.75-13.638-25.933-32.921-48.691-61.14-64.955.108-.479.256-1.07.407-1.484.534-1.459 1.328-2.935 2.229-4.402 1.613-2.625 4.394-5.64 6.928-8.119 6.339 9.216 13.09 14.765 20.543 18.36 12.917 6.231 28.923 5.754 52.418 6.45 9.611.29 18.212 4.512 25.214 9.617 9.384 6.842 16.167 15.274 17.348 19.45 2.033 7.188 7.01 11.531 14.319 13.145 7.168 1.584 19.801-1.369 32.96-9.941 20.043-13.054 42.213-38.546 46.086-67.349 1.544-10.965-7.574-27.73-26.484-45.175-29.253-26.988-81.768-61.195-118.737-88.628 3.56-9.022 9.458-24.437 10.744-30.561 3.832-18.255-8.05-26.375-16.313-28.651-10.04-2.745-30.784-4.613-54.643 3.098-14.417 4.66-29.927 13.074-44.861 26.913-4.04 3.825-10.081 3.688-16.741 4.772-9.889 1.609-20.998 3.171-32.912 6.418-9.531 2.598-19.525 6.179-29.75 11.698-47.378 26.066-92.179 83.879-120.538 151.368-25.763 61.313-38.512 129.876-29.692 186.465.35 2.905 4.553 10.541 16.003 11.419 10.626.814 33.525-.613 48.51-.696Z"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgCustodiaMark);

/***/ }),

/***/ 3419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Border; },
/* harmony export */   "P": function() { return /* binding */ gradientBackground; }
/* harmony export */ });
/* harmony import */ var _Users_kayce_thomas_devops_src_custodiabank_engineering_custodia_mono_claude_worktrees_sc_41628_static_site_deploy_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7328);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1895);


var _templateObject;



var gradientBackground = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject || (_templateObject = (0,_Users_kayce_thomas_devops_src_custodiabank_engineering_custodia_mono_claude_worktrees_sc_41628_static_site_deploy_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  background: linear-gradient(\n    270deg,\n    #fb5341 0%,\n    #d5a600 17%,\n    #41cd7f 69%,\n    #009789 100%\n  );\n"])));
var Border = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "styled__Border",
  componentId: "sc-12buf5n-0"
})(["", " ", ""], gradientBackground, {
  "@media (min-width: 1024px)": {
    "height": "0.125rem"
  }
});

/***/ }),

/***/ 1424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Seo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5351);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9597);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2322);





var Seo = function Seo(_ref) {
  var title = _ref.title,
      description = _ref.description,
      locale = _ref.locale,
      image = _ref.image;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  var url = "".concat(_config__WEBPACK_IMPORTED_MODULE_3__/* .site.host */ .l.host).concat(router.asPath);
  var hydratedTitle = title !== null && title !== void 0 ? title : _config__WEBPACK_IMPORTED_MODULE_3__/* .site.title */ .l.title;
  var hydratedDescription = description !== null && description !== void 0 ? description : _config__WEBPACK_IMPORTED_MODULE_3__/* .site.description */ .l.description;
  var images = image != null ? [image] : [{
    url: "".concat(_config__WEBPACK_IMPORTED_MODULE_3__/* .site.host */ .l.host, "/images/about/horses.webp")
  }];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
    canonical: url,
    title: hydratedTitle,
    description: hydratedDescription,
    openGraph: {
      title: hydratedTitle,
      description: hydratedDescription,
      url: url,
      locale: locale !== null && locale !== void 0 ? locale : 'en_US',
      type: 'article',
      site_name: _config__WEBPACK_IMPORTED_MODULE_3__/* .site.title */ .l.title,
      images: images
    }
  });
};

/***/ }),

/***/ 564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ShellWrapper; },
/* harmony export */   "v": function() { return /* binding */ ContentWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1895);

var ShellWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "styled__ShellWrapper",
  componentId: "sc-tmhqqf-0"
})(function (_ref) {
  var _ref$enableSnapPoints = _ref.enableSnapPoints,
      enableSnapPoints = _ref$enableSnapPoints === void 0 ? false : _ref$enableSnapPoints;
  return [{
    "display": "flex",
    "minHeight": "100vh",
    "minWidth": "min-content",
    "flexDirection": "column"
  }, enableSnapPoints && {
    "scrollPaddingTop": "72px",
    "@media (min-width: 1280px)": {
      "scrollSnapType": "y proximity"
    },
    "@media (max-height: 800px)": {
      "scrollSnapType": "none"
    }
  }];
});
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "styled__ContentWrapper",
  componentId: "sc-tmhqqf-1"
})(["flex-grow:1;", ""], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  ".dark &": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(34 34 34 / var(--tw-bg-opacity))"
  }
});

/***/ }),

/***/ 9597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ site; }
/* harmony export */ });
/* harmony import */ var _env__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8199);

var site = {
  title: 'Custodia Bank',
  host: _env__WEBPACK_IMPORTED_MODULE_0__/* .WWW_BASE_URL */ .Cw,
  description: 'Custodia provides a full suite of banking and financial services tailored to business customers looking for enhanced regulatory clarity, defined asset and balance sheet status for assets, and minimized transactional risk as they traverse the digital asset frontier.'
};

/***/ }),

/***/ 9612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useIsBrowser; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/*
  Next.js statically exports the initial HTML, so components that must only
  render in the browser (for example, the cookie banner) need to wait for
  hydration to complete. Returning state set in useEffect (rather than
  checking `typeof window` during render) keeps the first client render
  identical to the server HTML and avoids hydration mismatches.
 */

var useIsBrowser = function useIsBrowser() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isBrowser = _useState[0],
      setIsBrowser = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setIsBrowser(true);
  }, []);
  return isBrowser;
};

/***/ }),

/***/ 1159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ design_system_button; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../packages/design-system/link/src/index.tsx


var _excluded = ["children", "className", "href", "onClick", "type"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var DSLink = function DSLink(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      href = _ref.href,
      onClick = _ref.onClick,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'link' : _ref$type,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var Children = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    className: className,
    onClick: onClick,
    children: children
  }); // Look like a link but don't act like one


  if (typeof onClick == 'function') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: Children
    });
  }
  /**
   * NOTE: In the future it would be nice to check which outer HTML element
   * is the child, and if it is an <a> there is no need to pass
   * a type prop.
   */


  if (type === 'button') {
    Children = children;
  }
  /**
   * URL function was passed instead of the string result of the function
   * NOTE: Pages page will not understand this
   */


  if (typeof href == 'function' && true && window.location.pathname != '/pages') {
    console.error('Cannot pass url functions here; please resolve at parent.');
    console.log('href', href);
  }

  if (!href) {
    console.error('<Link> requires href prop.');
    console.log(props);
    console.log(Children);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), _objectSpread(_objectSpread({}, props), {}, {
    href: href,
    passHref: true,
    children: Children
  }));
};

/* harmony default export */ var src = (DSLink);
;// CONCATENATED MODULE: ../../packages/design-system/link/index.ts

/* harmony default export */ var design_system_link = (src);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
;// CONCATENATED MODULE: ../../packages/design-system/button/src/styles.tsx

var StyledButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-t1wasz-0"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], {
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "1rem",
  "whiteSpace": "nowrap",
  "borderRadius": "0.375rem",
  "borderWidth": "2px",
  "fontWeight": "500",
  "textTransform": "uppercase",
  "letterSpacing": "0.2rem"
}, function (_ref) {
  var size = _ref.size;
  return size === 'sm' && {
    "paddingLeft": "1rem",
    "paddingRight": "1rem",
    "paddingTop": "0.25rem",
    "paddingBottom": "0.25rem",
    "fontSize": "0.875rem",
    "lineHeight": "1.25rem",
    "letterSpacing": "0.05em"
  };
}, function (_ref2) {
  var size = _ref2.size;
  return size === 'md' && {
    "paddingLeft": "1.5rem",
    "paddingRight": "1.5rem",
    "paddingTop": "0.5rem",
    "paddingBottom": "0.5rem",
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "letterSpacing": "0.2rem"
  };
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'lg' && {
    "paddingLeft": "2rem",
    "paddingRight": "2rem",
    "paddingTop": "0.5rem",
    "paddingBottom": "0.5rem",
    "fontSize": "1.125rem",
    "lineHeight": "1.75rem",
    "letterSpacing": "0.2rem"
  };
}, {
  "--tw-border-opacity": "1",
  "borderColor": "rgb(255 196 37 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 196 37 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(0 0 0 / var(--tw-text-opacity))"
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return !disabled && {
    ":hover": {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(255 213 77 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 213 77 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(68 68 68 / var(--tw-text-opacity))"
    }
  };
}, function (_ref5) {
  var variety = _ref5.variety,
      themeColor = _ref5.themeColor;
  return variety === 'primary' && themeColor === 'black' && {
    "borderStyle": "none",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  };
}, function (_ref6) {
  var variety = _ref6.variety,
      themeColor = _ref6.themeColor,
      disabled = _ref6.disabled;
  return variety === 'primary' && themeColor === 'black' && !disabled && {
    ":hover": {
      "borderStyle": "none",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(34 34 34 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(255 255 255 / var(--tw-text-opacity))"
    }
  };
}, function (_ref7) {
  var variety = _ref7.variety,
      themeColor = _ref7.themeColor;
  return variety === 'primary' && themeColor === 'gray' && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(51 51 51 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(51 51 51 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  };
}, function (_ref8) {
  var variety = _ref8.variety,
      themeColor = _ref8.themeColor,
      disabled = _ref8.disabled;
  return variety === 'primary' && themeColor === 'gray' && !disabled && {
    ":hover": {
      "borderColor": "rgb(51 51 51 / 0.9)",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(51 51 51 / 0.9)",
      "--tw-text-opacity": "1",
      "color": "rgb(255 255 255 / var(--tw-text-opacity))"
    }
  };
}, function (_ref9) {
  var variety = _ref9.variety,
      themeColor = _ref9.themeColor;
  return variety === 'primary' && themeColor === 'carolina' && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(126 161 222 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(126 161 222 / var(--tw-bg-opacity))",
    ":hover": {
      "borderColor": "rgb(126 161 222 / 0.9)",
      "backgroundColor": "rgb(126 161 222 / 0.9)"
    }
  };
}, function (_ref10) {
  var variety = _ref10.variety,
      themeColor = _ref10.themeColor;
  return variety === 'primary' && themeColor === 'emerald' && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(65 205 127 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(65 205 127 / var(--tw-bg-opacity))",
    ":hover": {
      "borderColor": "rgb(65 205 127 / 0.9)",
      "backgroundColor": "rgb(65 205 127 / 0.9)"
    }
  };
}, function (_ref11) {
  var variety = _ref11.variety,
      themeColor = _ref11.themeColor;
  return variety === 'primary' && themeColor === 'rodeo-blue' && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(60 136 255 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(60 136 255 / var(--tw-bg-opacity))",
    ":hover": {
      "borderColor": "rgb(60 136 255 / 0.9)",
      "backgroundColor": "rgb(60 136 255 / 0.9)"
    }
  };
}, function (_ref12) {
  var variety = _ref12.variety,
      themeColor = _ref12.themeColor;
  return variety === 'primary' && themeColor === 'red' && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(251 83 65 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(251 83 65 / var(--tw-bg-opacity))",
    ":hover": {
      "borderColor": "rgb(251 83 65 / 0.9)",
      "backgroundColor": "rgb(251 83 65 / 0.9)"
    }
  };
}, function (_ref13) {
  var variety = _ref13.variety,
      themeColor = _ref13.themeColor;
  return variety === 'primary' && themeColor === 'topaz' && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(253 140 50 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(253 140 50 / var(--tw-bg-opacity))",
    ":hover": {
      "borderColor": "rgb(253 140 50 / 0.9)",
      "backgroundColor": "rgb(253 140 50 / 0.9)"
    }
  };
}, function (_ref14) {
  var variety = _ref14.variety,
      themeColor = _ref14.themeColor;
  return variety === 'primary' && themeColor === 'lilac' && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(195 117 255 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(195 117 255 / var(--tw-bg-opacity))",
    ":hover": {
      "borderColor": "rgb(195 117 255 / 0.9)",
      "backgroundColor": "rgb(195 117 255 / 0.9)"
    }
  };
}, function (_ref15) {
  var variety = _ref15.variety;
  return variety === 'secondary' && {
    "backgroundColor": "transparent",
    "--tw-text-opacity": "1",
    "color": "rgb(255 196 37 / var(--tw-text-opacity))"
  };
}, function (_ref16) {
  var variety = _ref16.variety,
      themeColor = _ref16.themeColor;
  return variety === 'secondary' && themeColor === 'carolina' && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(126 161 222 / var(--tw-border-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(126 161 222 / var(--tw-text-opacity))",
    ":disabled": {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(75 85 99 / var(--tw-border-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(75 85 99 / var(--tw-text-opacity))"
    }
  };
}, function (_ref17) {
  var variety = _ref17.variety,
      themeColor = _ref17.themeColor;
  return variety == 'secondary' && themeColor === 'emerald' && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(65 205 127 / var(--tw-border-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(65 205 127 / var(--tw-text-opacity))"
  };
}, function (_ref18) {
  var variety = _ref18.variety,
      themeColor = _ref18.themeColor;
  return variety == 'secondary' && themeColor === 'rodeo-blue' && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(60 136 255 / var(--tw-border-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(60 136 255 / var(--tw-text-opacity))"
  };
}, function (_ref19) {
  var variety = _ref19.variety,
      themeColor = _ref19.themeColor;
  return variety == 'secondary' && themeColor == 'black' && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(17 17 17 / var(--tw-border-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(17 17 17 / var(--tw-text-opacity))"
  };
}, function (_ref20) {
  var variety = _ref20.variety,
      themeColor = _ref20.themeColor;
  return variety == 'secondary' && themeColor == 'red' && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(251 83 65 / var(--tw-border-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(251 83 65 / var(--tw-text-opacity))"
  };
}, function (_ref21) {
  var variety = _ref21.variety,
      disabled = _ref21.disabled;
  return variety === 'secondary' && !disabled && {
    ":hover": {
      "backgroundColor": "rgb(255 196 37 / 0.15)",
      "--tw-text-opacity": "1",
      "color": "rgb(255 196 37 / var(--tw-text-opacity))"
    }
  };
}, function (_ref22) {
  var variety = _ref22.variety,
      disabled = _ref22.disabled,
      themeColor = _ref22.themeColor;
  return variety === 'secondary' && themeColor === 'carolina' && !disabled && {
    ":hover": {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(126 161 222 / var(--tw-border-opacity))",
      "backgroundColor": "rgb(126 161 222 / 0.15)",
      "--tw-text-opacity": "1",
      "color": "rgb(126 161 222 / var(--tw-text-opacity))"
    }
  };
}, function (_ref23) {
  var variety = _ref23.variety,
      disabled = _ref23.disabled,
      themeColor = _ref23.themeColor;
  return variety === 'secondary' && themeColor === 'emerald' && !disabled && {
    ":hover": {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(65 205 127 / var(--tw-border-opacity))",
      "backgroundColor": "rgb(65 205 127 / 0.15)",
      "--tw-text-opacity": "1",
      "color": "rgb(65 205 127 / var(--tw-text-opacity))"
    }
  };
}, function (_ref24) {
  var variety = _ref24.variety,
      disabled = _ref24.disabled,
      themeColor = _ref24.themeColor;
  return variety === 'secondary' && themeColor === 'rodeo-blue' && !disabled && {
    ":hover": {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(60 136 255 / var(--tw-border-opacity))",
      "backgroundColor": "rgb(60 136 255 / 0.15)",
      "--tw-text-opacity": "1",
      "color": "rgb(60 136 255 / var(--tw-text-opacity))"
    }
  };
}, function (_ref25) {
  var variety = _ref25.variety,
      disabled = _ref25.disabled,
      themeColor = _ref25.themeColor;
  return variety === 'secondary' && themeColor === 'black' && !disabled && {
    ":hover": {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(17 17 17 / var(--tw-border-opacity))",
      "backgroundColor": "rgb(17 17 17 / 0.15)",
      "--tw-text-opacity": "1",
      "color": "rgb(17 17 17 / var(--tw-text-opacity))"
    }
  };
}, function (_ref26) {
  var variety = _ref26.variety,
      disabled = _ref26.disabled,
      themeColor = _ref26.themeColor;
  return variety === 'secondary' && themeColor === 'red' && !disabled && {
    ":hover": {
      "--tw-border-opacity": "1",
      "borderColor": "rgb(251 83 65 / var(--tw-border-opacity))",
      "backgroundColor": "rgb(251 83 65 / 0.15)",
      "--tw-text-opacity": "1",
      "color": "rgb(251 83 65 / var(--tw-text-opacity))"
    }
  };
}, function (_ref27) {
  var variety = _ref27.variety;
  return variety === 'transparent' && {
    "borderWidth": "0px",
    "backgroundColor": "transparent",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  };
}, function (_ref28) {
  var variety = _ref28.variety,
      disabled = _ref28.disabled;
  return variety === 'transparent' && !disabled && {
    ":hover": {
      "--tw-text-opacity": "1",
      "color": "rgb(255 255 255 / var(--tw-text-opacity))",
      "backgroundColor": "#ffffff33"
    }
  };
}, function (_ref29) {
  var variety = _ref29.variety;
  return variety === 'text' && {
    "borderWidth": "0px",
    "backgroundColor": "transparent",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  };
}, function (_ref30) {
  var variety = _ref30.variety,
      disabled = _ref30.disabled;
  return variety === 'text' && !disabled && {
    ":hover": {
      "backgroundColor": "transparent",
      "--tw-text-opacity": "1",
      "color": "rgb(255 255 255 / var(--tw-text-opacity))",
      "opacity": "0.8"
    }
  };
}, function (_ref31) {
  var variety = _ref31.variety,
      themeColor = _ref31.themeColor;
  return variety === 'text' && themeColor === 'black' && {
    "--tw-text-opacity": "1",
    "color": "rgb(0 0 0 / var(--tw-text-opacity))"
  };
}, function (_ref32) {
  var variety = _ref32.variety,
      themeColor = _ref32.themeColor,
      disabled = _ref32.disabled;
  return variety === 'text' && themeColor === 'black' && !disabled && {
    ":hover": {
      "--tw-text-opacity": "1",
      "color": "rgb(0 0 0 / var(--tw-text-opacity))"
    }
  };
}, function (_ref33) {
  var variety = _ref33.variety,
      themeColor = _ref33.themeColor,
      disabled = _ref33.disabled;
  return variety === 'text' && themeColor === 'emerald' && !disabled && {
    "--tw-text-opacity": "1",
    "color": "rgb(65 205 127 / var(--tw-text-opacity))"
  };
}, function (_ref34) {
  var variety = _ref34.variety,
      themeColor = _ref34.themeColor,
      disabled = _ref34.disabled;
  return variety === 'text' && themeColor === 'carolina' && !disabled && {
    "--tw-text-opacity": "1",
    "color": "rgb(126 161 222 / var(--tw-text-opacity))",
    ":hover": {
      "--tw-text-opacity": "1",
      "color": "rgb(60 136 255 / var(--tw-text-opacity))"
    }
  };
}, function (_ref35) {
  var variety = _ref35.variety,
      themeColor = _ref35.themeColor,
      disabled = _ref35.disabled;
  return variety === 'text' && themeColor === 'red' && !disabled && {
    "--tw-text-opacity": "1",
    "color": "rgb(251 83 65 / var(--tw-text-opacity))",
    ":hover": {
      "--tw-text-opacity": "1",
      "color": "rgb(185 28 28 / var(--tw-text-opacity))"
    }
  };
}, function (_ref36) {
  var disabled = _ref36.disabled;
  return disabled && {
    "cursor": "not-allowed",
    "opacity": "0.6"
  };
}, function (_ref37) {
  var variety = _ref37.variety;
  return variety === 'text' && {
    "paddingLeft": "0.5rem",
    "paddingRight": "0.5rem",
    "paddingTop": "0.25rem",
    "paddingBottom": "0.25rem"
  };
}, function (_ref38) {
  var variety = _ref38.variety;
  return variety === 'icon' && {
    "borderWidth": "0px",
    "backgroundColor": "transparent",
    "padding": "0px",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))",
    ":hover": {
      "cursor": "pointer",
      "backgroundColor": "transparent"
    }
  };
});
var StyledLoader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__StyledLoader",
  componentId: "sc-t1wasz-1"
})(function (_ref39) {
  var _ref39$variety = _ref39.variety,
      variety = _ref39$variety === void 0 ? 'primary' : _ref39$variety,
      _ref39$themeColor = _ref39.themeColor,
      themeColor = _ref39$themeColor === void 0 ? 'gold' : _ref39$themeColor;
  return [{
    "height": "1.5rem",
    "width": "1.5rem",
    "@keyframes spin": {
      "to": {
        "transform": "rotate(360deg)"
      }
    },
    "animation": "spin 1s linear infinite",
    "borderRadius": "9999px",
    "borderWidth": "4px",
    "borderStyle": "solid"
  }, // Primary Button
  variety === 'primary' && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(0 0 0 / var(--tw-border-opacity))",
    "borderTopColor": "transparent"
  }, variety === 'primary' && themeColor === 'black' && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(255 255 255 / var(--tw-border-opacity))",
    "borderTopColor": "transparent"
  }, // Secondary Button
  variety === 'secondary' && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(255 196 37 / var(--tw-border-opacity))",
    "borderTopColor": "transparent"
  }, variety === 'secondary' && themeColor === 'carolina' && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(126 161 222 / var(--tw-border-opacity))",
    "borderTopColor": "transparent"
  }, // Transparent and Text Buttons
  (variety === 'transparent' || variety === 'text') && {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(255 255 255 / var(--tw-border-opacity))",
    "borderTopColor": "transparent"
  }, variety === 'text' && {
    "paddingLeft": "0px",
    "paddingRight": "0px"
  }];
});
;// CONCATENATED MODULE: ../../packages/design-system/button/src/index.tsx


var src_excluded = ["children", "href", "type", "disabled", "loading", "variety", "themeColor", "icon", "size"];

function src_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function src_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? src_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : src_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var DSButton = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      href = _ref.href,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$variety = _ref.variety,
      variety = _ref$variety === void 0 ? 'primary' : _ref$variety,
      _ref$themeColor = _ref.themeColor,
      themeColor = _ref$themeColor === void 0 ? 'gold' : _ref$themeColor,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? false : _ref$icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, src_excluded);

  var propsWithDefaults = src_objectSpread({
    disabled: disabled,
    variety: variety,
    themeColor: themeColor,
    icon: icon,
    size: size
  }, props);
  /**
   * If you're looking at this and thinking "that's weird" you're not alone.
   * Next.js requires their <Link> to wrap an <a>. Since the design system is
   * setup to auto provide an <a> so the developer doesn't have to remember
   * to do that, here the type="button" tells <Link> to not provide the
   * auto wrapped <a> as its being supplied here instead.
   */


  if (href) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(design_system_link, {
      href: href,
      type: "button",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, src_objectSpread(src_objectSpread({
        as: 'a'
      }, propsWithDefaults), {}, {
        ref: ref,
        children: children
      }))
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledButton, src_objectSpread(src_objectSpread({}, propsWithDefaults), {}, {
    type: type,
    disabled: disabled || loading,
    ref: ref,
    children: [loading && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLoader, {
      variety: variety,
      themeColor: themeColor
    }), children]
  }));
});
/* harmony default export */ var button_src = (DSButton);
;// CONCATENATED MODULE: ../../packages/design-system/button/index.ts

/* harmony default export */ var design_system_button = (button_src);

/***/ }),

/***/ 86:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cookie_banner; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 5 modules
var slicedToArray = __webpack_require__(7113);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
// EXTERNAL MODULE: ../../packages/design-system/button/index.ts + 4 modules
var design_system_button = __webpack_require__(1159);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
;// CONCATENATED MODULE: ../../packages/design-system/banner/src/styles.tsx

var styles_Banner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Banner",
  componentId: "sc-hf1ov7-0"
})(["", " ", ""], {
  "paddingTop": "1.25rem",
  "paddingBottom": "1.25rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "@media (min-width: 1024px)": {
    "paddingLeft": "2rem",
    "paddingRight": "2rem"
  }
}, function (_ref) {
  var _ref$variety = _ref.variety,
      variety = _ref$variety === void 0 ? 'emerald' : _ref$variety;
  return variety === 'gold' ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 196 37 / var(--tw-bg-opacity))"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(65 205 127 / var(--tw-bg-opacity))"
  };
});
var BannerInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__BannerInner",
  componentId: "sc-hf1ov7-1"
})(["", " ", " ", " a{", "}"], {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "1rem",
  "--tw-text-opacity": "1",
  "color": "rgb(0 0 0 / var(--tw-text-opacity))",
  "@media (min-width: 768px)": {
    "flexDirection": "row"
  }
}, function (_ref2) {
  var _ref2$constrainConten = _ref2.constrainContentWidth,
      constrainContentWidth = _ref2$constrainConten === void 0 ? true : _ref2$constrainConten;
  return constrainContentWidth && {
    "marginLeft": "auto",
    "marginRight": "auto",
    "maxWidth": "64rem"
  };
}, function (_ref3) {
  var _ref3$textSize = _ref3.textSize,
      textSize = _ref3$textSize === void 0 ? 'base' : _ref3$textSize;
  return textSize === 'lg' ? {
    "fontSize": "1.125rem",
    "lineHeight": "1.75rem"
  } : {
    "fontSize": "1rem",
    "lineHeight": "1.5rem"
  };
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(0 0 0 / var(--tw-text-opacity))",
  "textDecorationLine": "underline"
});
var BannerButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__BannerButtons",
  componentId: "sc-hf1ov7-2"
})(["", ""], {
  "display": "flex",
  "width": "100%",
  "justifyContent": "flex-end",
  "gap": "2rem",
  "--tw-text-opacity": "1",
  "color": "rgb(0 0 0 / var(--tw-text-opacity))",
  "@media (min-width: 768px)": {
    "width": "fit-content"
  }
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../packages/design-system/banner/src/index.tsx


var _excluded = ["title", "onClick", "variety", "themeColor"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Banner = function Banner(_ref) {
  var _buttons$variety, _buttons$themeColor;

  var _ref$variety = _ref.variety,
      variety = _ref$variety === void 0 ? 'emerald' : _ref$variety,
      message = _ref.message,
      buttons = _ref.buttons,
      textSize = _ref.textSize,
      constrainContentWidth = _ref.constrainContentWidth;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(styles_Banner, {
    variety: variety,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(BannerInner, {
      textSize: textSize,
      constrainContentWidth: constrainContentWidth,
      children: [typeof message === 'string' ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: message
      }) : message, /*#__PURE__*/(0,jsx_runtime.jsx)(BannerButtons, {
        children: Array.isArray(buttons) ? buttons.map(function (_ref2) {
          var title = _ref2.title,
              onClick = _ref2.onClick,
              variety = _ref2.variety,
              themeColor = _ref2.themeColor,
              rest = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

          return /*#__PURE__*/(0,jsx_runtime.jsx)(design_system_button/* default */.Z, _objectSpread(_objectSpread({
            variety: variety !== null && variety !== void 0 ? variety : 'primary',
            themeColor: themeColor !== null && themeColor !== void 0 ? themeColor : 'black',
            onClick: onClick
          }, rest), {}, {
            children: title
          }), title);
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(design_system_button/* default */.Z, _objectSpread(_objectSpread({}, buttons), {}, {
          variety: (_buttons$variety = buttons.variety) !== null && _buttons$variety !== void 0 ? _buttons$variety : 'primary',
          themeColor: (_buttons$themeColor = buttons.themeColor) !== null && _buttons$themeColor !== void 0 ? _buttons$themeColor : 'black',
          onClick: buttons.onClick,
          children: buttons.title
        }))
      })]
    })
  });
};
;// CONCATENATED MODULE: ../../packages/design-system/banner/index.ts

/* harmony default export */ var banner = (Banner);
;// CONCATENATED MODULE: ../../packages/design-system/cookie-banner/styles.ts

var CookieBannerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__CookieBannerContainer",
  componentId: "sc-1kluawu-0"
})(["", ""], {
  "position": "sticky",
  "left": "0px",
  "right": "0px",
  "bottom": "0px",
  "zIndex": "50"
});
// EXTERNAL MODULE: ../../packages/design-system/cookie-banner/useCookiePrefCookie.ts + 1 modules
var useCookiePrefCookie = __webpack_require__(9395);
;// CONCATENATED MODULE: ../../packages/design-system/cookie-banner/index.tsx








var CookieBanner = function CookieBanner() {
  var _useCookiePrefCookie = (0,useCookiePrefCookie/* useCookiePrefCookie */.B)(),
      _useCookiePrefCookie2 = (0,slicedToArray/* default */.Z)(_useCookiePrefCookie, 3),
      setCookie = _useCookiePrefCookie2[1],
      displayCookieBanner = _useCookiePrefCookie2[2];

  return displayCookieBanner && /*#__PURE__*/(0,jsx_runtime.jsx)(CookieBannerContainer, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(banner, {
      variety: 'gold',
      constrainContentWidth: false,
      message: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["By continuing to browse this site, you consent to the use of cookies or similar technologies. Please see our", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: '/legal/privacy-notice/',
          children: "Privacy Notice"
        }), " for further information."]
      }),
      buttons: [{
        title: 'Reject',
        onClick: function onClick() {
          setCookie('rejected');
        },
        variety: 'text'
      }, {
        title: 'Accept',
        onClick: function onClick() {
          setCookie('accepted');
        },
        variety: 'primary',
        themeColor: 'black'
      }]
    })
  });
};

/* harmony default export */ var cookie_banner = (CookieBanner);

/***/ }),

/***/ 2890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ footer; }
});

// UNUSED EXPORTS: BottomCopyrightLine, MmfDisclosure, NotFdicInsuredDisclosure

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
;// CONCATENATED MODULE: ../../packages/design-system/footer/src/styles.tsx

var styles_Footer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styles__Footer",
  componentId: "sc-h9qm4b-0"
})(["", ""], {
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "scrollSnapAlign": "end"
  }
});
var FooterTop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__FooterTop",
  componentId: "sc-h9qm4b-1"
})(["", " ", ""], {
  "display": "grid",
  "width": "100%",
  "gap": "2.5rem",
  "@media (min-width: 768px)": {
    "gridTemplateColumns": "repeat(2, minmax(0, 1fr))"
  }
}, {
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingTop": "2.5rem",
  "@media (min-width: 1024px)": {
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem"
  }
});
var FooterTopLeft = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__FooterTopLeft",
  componentId: "sc-h9qm4b-2"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column",
  "gap": "1.5rem"
});
var TitleSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__TitleSection",
  componentId: "sc-h9qm4b-3"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem"
});
var TitleHeader = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "styles__TitleHeader",
  componentId: "sc-h9qm4b-4"
})(["", ""], {
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem",
  "fontWeight": "600"
});
var InfoLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "styles__InfoLink",
  componentId: "sc-h9qm4b-5"
})(["", ""], {
  "width": "min-content",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(65 205 127 / var(--tw-text-opacity))",
  "textDecorationLine": "underline"
});
var MountainWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__MountainWrapper",
  componentId: "sc-h9qm4b-6"
})(["", ""], {
  "width": "fit-content"
});
var MountainImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "styles__MountainImage",
  componentId: "sc-h9qm4b-7"
})(["", ""], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "maxHeight": "37px"
});
var MadeInWyomingHeader = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
  displayName: "styles__MadeInWyomingHeader",
  componentId: "sc-h9qm4b-8"
})(["font-size:0.7rem;line-height:1rem;", ""], {
  "marginTop": "-0.55rem",
  "marginLeft": "0.75rem"
});
var NavigationSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__NavigationSection",
  componentId: "sc-h9qm4b-9"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem",
  "@media (min-width: 768px)": {
    "textAlign": "right"
  }
});
var NavigationHeader = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "styles__NavigationHeader",
  componentId: "sc-h9qm4b-10"
})(["", ""], {
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  "fontWeight": "600"
});
var NavigationList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styles__NavigationList",
  componentId: "sc-h9qm4b-11"
})(["", " a{", "}"], {
  "display": "flex",
  "listStyleType": "none",
  "flexDirection": "column",
  "gap": "0.5rem",
  "fontWeight": "300"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "textDecorationLine": "none"
});
var FooterBottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__FooterBottom",
  componentId: "sc-h9qm4b-12"
})(["", " ", ""], {
  "display": "flex",
  "flexDirection": "column"
}, {
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingBottom": "1.5rem",
  "paddingTop": "2.5rem",
  "@media (min-width: 768px)": {
    "paddingTop": "0px"
  },
  "@media (min-width: 1024px)": {
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem"
  }
});
var DisclaimerSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__DisclaimerSection",
  componentId: "sc-h9qm4b-13"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem",
  "paddingTop": "0.5rem",
  "@media (min-width: 768px)": {
    "paddingTop": "1.5rem"
  }
});
var DisclaimerHeader = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "styles__DisclaimerHeader",
  componentId: "sc-h9qm4b-14"
})(["", ""], {
  "fontSize": "0.75rem",
  "lineHeight": "1rem",
  "fontWeight": "600"
});
var DisclaimerParagraph = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styles__DisclaimerParagraph",
  componentId: "sc-h9qm4b-15"
})(["font-size:0.625rem;line-height:0.7rem;", ""], {
  "fontWeight": "300"
});
var DBAParagraph = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styles__DBAParagraph",
  componentId: "sc-h9qm4b-16"
})(["line-height:0.7rem;", ""], {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "300"
});
var styles_NotFdicInsuredDisclosure = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__NotFdicInsuredDisclosure",
  componentId: "sc-h9qm4b-17"
})(["", ""], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "marginTop": "2rem",
  "borderWidth": "2px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(65 205 127 / var(--tw-border-opacity))",
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem"
});
var MmfDisclosure = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styles__MmfDisclosure",
  componentId: "sc-h9qm4b-18"
})(["", " > svg{", "}"], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "marginTop": "2rem",
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "0.5rem",
  "borderWidth": "2px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(65 205 127 / var(--tw-border-opacity))",
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "textTransform": "uppercase"
}, {
  "height": "1.25rem",
  "width": "1.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(65 205 127 / var(--tw-text-opacity))"
});
var styles_BottomCopyrightLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__BottomCopyrightLine",
  componentId: "sc-h9qm4b-19"
})(["font-size:0.65rem;line-height:0.75rem;", ""], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "marginTop": "1rem",
  "display": "flex",
  "gap": "0.75rem",
  "justifySelf": "center"
});
var CopyrightLineGrouping = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__CopyrightLineGrouping",
  componentId: "sc-h9qm4b-20"
})(["", " span{", "}a,button{", "}"], {
  "display": "flex",
  "gap": "0.5rem",
  "whiteSpace": "nowrap",
  "fontWeight": "300",
  "--tw-text-opacity": "1",
  "color": "rgb(151 151 151 / var(--tw-text-opacity))"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(151 151 151 / var(--tw-text-opacity))"
}, {
  "cursor": "pointer",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "textDecorationLine": "underline"
});
var BottomBorder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__BottomBorder",
  componentId: "sc-h9qm4b-21"
})(["", ""], {
  "height": "0.25rem",
  "width": "100%",
  "backgroundImage": "linear-gradient(to right, var(--tw-gradient-stops))",
  "--tw-gradient-from": "#ffc425",
  "--tw-gradient-to": "#FB5341",
  "--tw-gradient-stops": "var(--tw-gradient-from), var(--tw-gradient-to)"
});
var Footnote = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "styles__Footnote",
  componentId: "sc-h9qm4b-22"
})(["", " span{font-family:'Lora',serif;}"], {
  "display": "block"
});
var DBALink = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "styles__DBALink",
  componentId: "sc-h9qm4b-23"
})(["", ""], {
  "cursor": "pointer",
  "--tw-text-opacity": "1",
  "color": "rgb(65 205 127 / var(--tw-text-opacity))",
  "textDecorationLine": "underline"
});
var NMLS = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styles__NMLS",
  componentId: "sc-h9qm4b-24"
})(["", ""], {
  "fontSize": "0.75rem",
  "lineHeight": "1rem"
});
;// CONCATENATED MODULE: ../../packages/design-system/footer/src/utils.ts
//This is only in its own function to mock it easier... HAHAH! what a loser, I bet its own mom doesn't even love it.
var getWWWBaseUrl = function getWWWBaseUrl() {
  return "https://custodiabank.com";
};
var CAREERS_URL = 'https://app.trinethire.com/companies/37151-custodia-bank-inc/jobs/embed';
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../packages/design-system/footer/src/index.tsx







var WWW_BASE_URL = getWWWBaseUrl();
var NMLS_NUMBER = '2129447';

var indexRouteDisclaimers = /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: 'https://flickr.com/photos/danielsphotography/466427534',
      children: "Photo from Flickr"
    }), ", used under", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: 'https://creativecommons.org/licenses/by/2.0/',
      children: "CC license"
    })]
  }, "credits")
});

var Footer = function Footer(_ref) {
  var _ref$displayNavigatio = _ref.displayNavigationLinks,
      displayNavigationLinks = _ref$displayNavigatio === void 0 ? true : _ref$displayNavigatio;

  var _useState = (0,react.useState)(false),
      loadAdditionalDisclaimers = _useState[0],
      setLoadAdditionalDisclaimers = _useState[1];

  (0,react.useEffect)(function () {
    //Doing this in an Effect to keep this component SSR-friendly
    if (window.location.href == "".concat(getWWWBaseUrl(), "/")) {
      setLoadAdditionalDisclaimers(true);
    }
  }, [loadAdditionalDisclaimers]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styles_Footer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FooterTop, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FooterTopLeft, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TitleSection, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TitleHeader, {
            children: "Custodia"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NMLS, {
            children: ["NMLS # ", NMLS_NUMBER]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(InfoLink, {
            href: 'mailto: info@custodiabank.com',
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "info@custodiabank.com"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DBAParagraph, {
            children: ["In certain US states, Custodia Bank, Inc. operates as", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              target: "_blank",
              rel: "noopener noreferrer",
              href: "".concat(WWW_BASE_URL, "/dba"),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(DBALink, {
                children: "Custodia Digital Services"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DBAParagraph, {
            children: "Custodia Bank, Inc. is not recognized as a bank in Maryland"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MountainWrapper, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MountainImage, {
            alt: 'colorful mountain range',
            src: "".concat(WWW_BASE_URL, "/images/footer-mountain-outline.png")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(MadeInWyomingHeader, {
            children: "Made in Wyoming"
          })]
        })]
      }), displayNavigationLinks && /*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationSection, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavigationHeader, {
          children: "Navigation"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(NavigationList, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavigationItem, {
            href: "".concat(WWW_BASE_URL, "/press"),
            title: 'Press'
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationItem, {
            href: "".concat(WWW_BASE_URL, "/about"),
            title: 'About'
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationItem, {
            href: CAREERS_URL,
            title: 'Careers',
            target: '_blank'
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FooterBottom, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DisclaimerSection, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DisclaimerHeader, {
          children: "Disclaimer"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DisclaimerParagraph, {
          children: ["Some services not currently available. All services, products, and access subject to applicable BSA/AML and other screening and documentary requirements.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Information provided on this website does not, and is not intended to, constitute tax or legal advice. You should consult your own tax, legal and accounting advisors before using any of Custodia Bank, Inc.'s products or services."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DisclaimerParagraph, {
          children: ["To report a bug or vulnerability please contact", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: 'mailto: bugreport@custodiabank.com',
            children: "bugreport@custodiabank.com"
          }), "."]
        }), loadAdditionalDisclaimers && /*#__PURE__*/(0,jsx_runtime.jsx)(DisclaimerParagraph, {
          children: indexRouteDisclaimers
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(NotFdicInsuredDisclosure, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(BottomCopyrightLine, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BottomBorder, {})]
  });
};

/* harmony default export */ var src = (Footer);
var NotFdicInsuredDisclosure = function NotFdicInsuredDisclosure() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(styles_NotFdicInsuredDisclosure, {
    children: "Not FDIC Insured"
  });
};
var src_MmfDisclosure = function MmfDisclosure(_ref2) {
  var onClick = _ref2.onClick;
  return /*#__PURE__*/_jsxs(S.MmfDisclosure, {
    onClick: onClick,
    children: [/*#__PURE__*/_jsx("span", {
      children: "DEPOSITS AND INVESTMENTS ARE NOT GUARANTEED BY ANY FEDERAL OR STATE GOVERNMENTAL AGENCY AND MAY LOSE VALUE"
    }), /*#__PURE__*/_jsx(MdOpenInNew, {})]
  });
};
var BottomCopyrightLine = function BottomCopyrightLine() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styles_BottomCopyrightLine, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CopyrightLineGrouping, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "".concat(WWW_BASE_URL, "/legal/terms-of-service"),
        target: '_blank',
        rel: 'noreferrer noopener',
        children: "Terms of Service"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "|"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "".concat(WWW_BASE_URL, "/licenses-and-disclosures"),
        target: '_blank',
        rel: 'noreferrer noopener',
        children: "Licenses and Disclosures"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "|"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "".concat(WWW_BASE_URL, "/legal/privacy-notice"),
        target: '_blank',
        rel: 'noreferrer noopener',
        children: "Privacy"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CopyrightLineGrouping, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        children: ["\xA9 ", new Date().getFullYear(), " Custodia Bank, Inc."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "|"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "All Rights Reserved."
      })]
    })]
  });
};

var NavigationItem = function NavigationItem(_ref3) {
  var href = _ref3.href,
      title = _ref3.title,
      _ref3$target = _ref3.target,
      target = _ref3$target === void 0 ? null : _ref3$target;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      target: target,
      href: href,
      children: title
    })
  });
};
;// CONCATENATED MODULE: ../../packages/design-system/footer/index.ts

/* harmony default export */ var footer = (src);


/***/ })

}]);